<div class="max-w-5xl mx-auto mt-10">
  <h3 class="text-2xl font-bold mb-6">Vendor Management</h3>


  <table class="w-full table-auto border border-gray-300 shadow-lg rounded-xl overflow-hidden">
    <thead class="bg-gray-100 text-left">
      <tr>
        <th class="px-4 py-2">Store Name</th>
        <th class="px-4 py-2">Email</th>
        <th class="px-4 py-2">Status</th>
        <th class="px-4 py-2">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let v of vendors" class="border-t">
        <td class="px-4 py-2">{{ v.storeName }}</td>
        <td class="px-4 py-2">{{ v.contactEmail }}</td>
        <td class="px-4 py-2">
          <span *ngIf="v.isApproved" class="text-green-600 font-semibold">Approved</span>
          <span *ngIf="!v.isApproved" class="text-yellow-600 font-semibold">Pending</span>
        </td>
        <td class="px-4 py-2 space-x-2">
          <button *ngIf="!v.isApproved" (click)="approve(v.vendorId)"
                  class="bg-green-600 text-white px-3 py-1 rounded-xl hover:bg-green-700">
            Approve
          </button>
          <button (click)="reject(v.vendorId)"
                  class="bg-red-600 text-white px-3 py-1 rounded-xl hover:bg-red-700">
            Reject
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
